import { useMutation } from '@tanstack/react-query';

import { apiClient } from 'api/ApiClient';
import type { ProfileResponse } from 'entities/user/types';

export const useUpdateProfile = () => {
  const { isPending, mutate, error } = useMutation({
    mutationFn: (data: Partial<ProfileResponse>) => apiClient.updateProfile(data),
  });

  return {
    isUpdating: isPending,
    updateProfile: mutate,
    error,
  };
};
